import { render, staticRenderFns } from "./BtnCustom.vue?vue&type=template&id=7c9d2034&lang=pug&"
import script from "./BtnCustom.vue?vue&type=script&lang=js&"
export * from "./BtnCustom.vue?vue&type=script&lang=js&"
import style0 from "./BtnCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports